import React from 'react';
import { Box, CardActionArea, CardContent, Grid, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { IconShoppingCart, IconTruckDelivery, IconArrowsRightLeft, IconBoxSeam, IconChartInfographic } from '@tabler/icons';
import { useHistory } from 'react-router-dom';
import PageHeader from '../../../../../ui-component/extended/PageHeader';
import GlassCard from '../../../../../ui-component/extended/GlassCard';
import GradientIconBadge from '../../../../../ui-component/extended/GradientIconBadge';
import { gradients } from '../../../../../themes/gradients';

const REPORTS = [
    {
        title: 'Vendas',
        description: 'Total vendido por período e produtos mais vendidos (com margem)',
        icon: IconShoppingCart,
        gradient: 'teal',
        url: '/dashboard/reports/sales'
    },
    {
        title: 'Compras',
        description: 'Total comprado por período e principais fornecedores',
        icon: IconTruckDelivery,
        gradient: 'blue',
        url: '/dashboard/reports/purchasing'
    },
    {
        title: 'Contas em aberto (aging)',
        description: 'Contas a pagar/receber em aberto, agrupadas por faixa de atraso',
        icon: IconArrowsRightLeft,
        gradient: 'coral',
        url: '/dashboard/reports/financial-aging'
    },
    {
        title: 'Estoque valorizado',
        description: 'Valor do estoque atual, em custo e em potencial de venda',
        icon: IconBoxSeam,
        gradient: 'amber',
        url: '/dashboard/reports/inventory-valuation'
    }
];

const ReportsHome = () => {
    const history = useHistory();

    return (
        <Box>
            <PageHeader icon={IconChartInfographic} gradient="graphite" title="Relatórios" subtitle="Escolha um relatório" />

            <Grid container spacing={2}>
                {REPORTS.map((report, index) => (
                    <Grid item xs={12} sm={6} md={3} key={report.url}>
                        <Box
                            component={motion.div}
                            initial={{ opacity: 0, y: 16 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.35, delay: index * 0.06, ease: [0.4, 0, 0.2, 1] }}
                            sx={{ height: '100%' }}
                        >
                            <GlassCard accent={gradients[report.gradient].main} sx={{ height: '100%' }}>
                                <CardActionArea sx={{ height: '100%', p: 1 }} onClick={() => history.push(report.url)}>
                                    <CardContent>
                                        <GradientIconBadge icon={report.icon} gradient={report.gradient} size={48} />
                                        <Typography variant="h6" fontWeight={700} mt={2}>
                                            {report.title}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {report.description}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </GlassCard>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default ReportsHome;
